(function () {
  'use strict';
  if (window.__willowCollectionActions) return;
  window.__willowCollectionActions = true;

  var STORAGE_KEY = 'willow.compare.v1';
  var MAX_COMPARE = 4;
  var differencesOnly = false;

  // Technical drilling services stay cart add-ons, never saved-list products.
  function isService(item) {
    if (!item) return false;
    var id = String(item.productId || item.empi || '').split('/').pop();
    if (['10076688515351', '10539203494167', '10539203592471'].indexOf(id) !== -1) return true;
    var match = String(item.du || item.url || '').match(/\/products\/([^/?#]+)/);
    var handle = String(item.handle || (match && match[1]) || '').toLowerCase();
    return /^(?:single-handle-configuration|4-in-centerset-faucet-configuration(?:-double-sink)?)$/.test(handle)
      || /faucet-(?:configuration|modification)/.test(handle)
      || item.productType === 'countertop_service';
  }

  function readItems() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(function(item) { return item && !isService(item); }).slice(0, MAX_COMPARE) : [];
    } catch (_) {
      return [];
    }
  }

  function writeItems(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.filter(function(item) { return item && !isService(item); }).slice(0, MAX_COMPARE))); } catch (_) {}
  }

  function keyFor(item) { return String(item.handle || item.productId || '') + ':' + String(item.variantId || ''); }

  function itemFromButton(button) {
    return {
      productId: button.dataset.productId || '',
      variantId: button.dataset.variantId || '',
      handle: button.dataset.handle || '',
      title: button.dataset.title || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price: button.dataset.price || '',
      finish: button.dataset.finish || '—',
      width: button.dataset.width || '—',
      sink: button.dataset.sink || '—',
      mounting: button.dataset.mounting || '—',
      material: button.dataset.material || '—',
      sku: button.dataset.sku || '—',
      eta: button.dataset.eta || '—'
    };
  }

  function formatDimension(value) {
    var text = String(value == null ? '' : value).trim();
    if (!text || text === '—') return 'Not specified';
    text = text.replace(/\(in\.\)/gi, 'in.').replace(/\s+/g, ' ');
    if (/^\d+(?:\.\d+)?(?:[ -]\d+\/\d+)?$/.test(text)) text += ' in.';
    return text;
  }

  var specRequests = new Map();
  var hydrationId = 0;
  function loadSpecs(item) {
    var key = keyFor(item);
    if (specRequests.has(key)) return specRequests.get(key);
    var url = new URL((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(item.handle), location.origin);
    if (item.variantId) url.searchParams.set('variant', item.variantId);
    url.searchParams.set('section_id', 'willow-compare-data');
    var request = fetch(url, {credentials: 'same-origin'}).then(function(response) {
      if (!response.ok) throw new Error('Specifications unavailable');
      return response.text();
    }).then(function(html) {
      var element = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wv-compare-specs]');
      if (!element) throw new Error('Specifications unavailable');
      var data = JSON.parse(element.textContent), specs = data.specs || {};
      if (item.variantId && String(data.variantId) !== String(item.variantId)) throw new Error('Selected configuration unavailable');
      if (item.productId && String(data.productId) !== String(item.productId)) throw new Error('Product specifications do not match');
      var get = function(name) {return specs[name] || 'Not specified';};
      var dimension = function(name) {return formatDimension(specs[name]);};
      var storage = Object.keys(specs).filter(function(name) {
        return /^(number of )?(drawers|doors|shelves)$|^storage$/.test(name);
      }).map(function(name) {
        var label = name.replace('number of ', '');
        return label.charAt(0).toUpperCase() + label.slice(1) + ': ' + specs[name];
      }).join(' · ');
      var cabinetOnly = /cabinet\s*only/i.test(data.top || '');
      return {specVersion: 3, countertop: cabinetOnly ? 'Not included — Cabinet Only' : data.top || 'Not specified',
        cabinetWidth: dimension('cabinet width'), depth: dimension('cabinet depth'), height: dimension('cabinet height'),
        topWidth: cabinetOnly ? 'Not included' : dimension('countertop width'),
        topDepth: cabinetOnly ? 'Not included' : dimension('countertop depth'),
        storage: storage || 'Not specified', hardware: get('hardware')};
    }).finally(function() {specRequests.delete(key);});
    specRequests.set(key, request);
    return request;
  }

  async function hydrateComparison(dialog) {
    var requestId = ++hydrationId;
    var items = readItems();
    var status = dialog.querySelector('[data-wv-compare-status]');
    status.textContent = 'Loading specifications…';
    dialog.setAttribute('aria-busy', 'true');
    var results = await Promise.allSettled(items.map(async function(item) {
      return {key: keyFor(item), specs: await loadSpecs(item)};
    }));
    if (requestId !== hydrationId) return;
    var current = readItems();
    results.forEach(function(result) {
      if (result.status !== 'fulfilled') return;
      var item = current.find(function(x) {return keyFor(x) === result.value.key;});
      if (item) Object.assign(item, result.value.specs);
    });
    writeItems(current);
    renderTable(dialog, current);
    dialog.removeAttribute('aria-busy');
    status.textContent = results.some(function(result) {return result.status === 'rejected';})
      ? 'Some specifications could not load. Open the product for details.' : '';
  }

  function emit(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
  }

  function placeCompareTray(tray) {
    if (!tray) return;
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 1280px)').matches;
    var topbar = isDesktop ? document.querySelector('.collection__topbar .facet-topbar') : null;
    var host = topbar || document.body;

    if (tray.parentNode !== host) {
      if (topbar) {
        var gridSwitch = topbar.querySelector('[data-wv-desktop-grid-switch]');
        topbar.insertBefore(tray, gridSwitch || null);
      } else {
        document.body.appendChild(tray);
      }
    }
    tray.classList.toggle('wv-compare-tray--topbar', Boolean(topbar));
  }

  function ensureCompareUi() {
    var tray = document.querySelector('[data-wv-compare-tray]');
    if (!tray) {
      tray = document.createElement('aside');
      tray.className = 'wv-compare-tray';
      tray.hidden = true;
      tray.setAttribute('data-wv-compare-tray', '');
      tray.setAttribute('aria-live', 'polite');
      tray.innerHTML = '<div class="wv-compare-tray__inner"><div class="wv-compare-tray__copy"><p class="wv-compare-tray__title"><span data-wv-compare-count>0</span> selected</p><p class="wv-compare-tray__hint" data-wv-compare-hint>Select at least 2 and up to 4 vanities.</p></div><div class="wv-compare-tray__buttons"><button type="button" data-wv-compare-clear aria-label="Clear comparison" title="Clear comparison"><span class="wv-compare-clear-label">Clear</span><span class="wv-compare-clear-icon" aria-hidden="true">×</span></button><button type="button" data-wv-compare-open disabled><svg class="wv-compare-open-icon" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="6" height="16" rx="1.5"/><rect x="14" y="4" width="6" height="16" rx="1.5"/></svg><span class="wv-compare-open-label">Compare</span><span class="wv-compare-open-count" aria-hidden="true"><span data-wv-compare-count>0</span>/4</span></button></div></div>';
      document.body.appendChild(tray);
    }

    placeCompareTray(tray);

    var dialog = document.querySelector('[data-wv-compare-dialog]');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'wv-compare-dialog';
      dialog.setAttribute('data-wv-compare-dialog', '');
      dialog.setAttribute('aria-labelledby', 'WillowCompareTitle');
      dialog.innerHTML = '<div class="wv-compare-dialog__head"><h2 id="WillowCompareTitle">Compare vanities</h2><button type="button" data-wv-compare-close aria-label="Close comparison">Close</button></div><label class="wv-compare-differences"><input type="checkbox" data-wv-compare-differences> Show only differences</label><p class="wv-compare-status" data-wv-compare-status role="status"></p><div class="wv-compare-dialog__body" data-wv-compare-body></div>';
      document.body.appendChild(dialog);
    }
    return { tray: tray, dialog: dialog };
  }

  function escapeText(value) { return String(value == null ? '' : value); }

  function renderTable(dialog, items) {
    var body = dialog.querySelector('[data-wv-compare-body]');
    if (!body) return;
    body.textContent = '';
    var table = document.createElement('table');
    table.className = 'wv-compare-table';
    // A small, semantic column header stays visible independently of the photos.
    var thead = document.createElement('thead');
    var header = document.createElement('tr');
    var corner = document.createElement('th');
    corner.scope = 'col';
    corner.textContent = 'Product';
    header.appendChild(corner);
    items.forEach(function (item) {
      var cell = document.createElement('th');
      cell.scope = 'col';
      cell.className = 'wv-compare-column';
      var link = document.createElement('a');
      link.href = item.url;
      link.title = escapeText(item.title);
      link.textContent = escapeText(item.title).replace(/\s+W\s*[x×].*$/i, '');
      cell.appendChild(link);
      if (item.countertop && item.countertop !== 'Not specified') {
        var top = document.createElement('small');
        top.textContent = item.countertop;
        cell.appendChild(top);
      }
      header.appendChild(cell);
    });
    thead.appendChild(header);
    table.appendChild(thead);
    var tbody = document.createElement('tbody');
    table.appendChild(tbody);

    function addRow(label, values, className) {
      var normalized = values.map(function(value){return String(value == null ? '—' : value).trim().replace(/\s+/g,' ').toLowerCase();});
      if(differencesOnly && items.length > 1 && label !== 'Product' && normalized.every(function(value){return value === normalized[0];})) return;
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.scope = 'row';
      th.textContent = label;
      tr.appendChild(th);
      values.forEach(function (value, index) {
        var td = document.createElement('td');
        if (className) td.className = className;
        if (label === 'Product') {
          var item = items[index];
          if (item.image) {
            var img = document.createElement('img');
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            td.appendChild(img);
          }
          var link = document.createElement('a');
          link.href = item.url;
          link.textContent = escapeText(item.title);
          td.appendChild(link);
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'wv-compare-remove';
          remove.dataset.wvCompareRemove = keyFor(item);
          remove.textContent = 'Remove';
          td.appendChild(document.createElement('br'));
          td.appendChild(remove);
        } else {
          td.textContent = escapeText(value || '—');
        }
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    }

    addRow('Product', items.map(function (x) { return x.title; }), 'wv-compare-product');
    addRow('Price', items.map(function (x) { return x.price; }));
    addRow('Finish', items.map(function (x) { return x.finish; }));
    addRow('Nominal size', items.map(function (x) { return formatDimension(x.width); }));
    addRow('Cabinet width', items.map(function (x) { return x.cabinetWidth; }));
    addRow('Cabinet depth', items.map(function (x) { return x.depth; }));
    addRow('Cabinet height', items.map(function (x) { return x.height; }));
    addRow('Countertop', items.map(function (x) { return x.countertop; }));
    addRow('Countertop width', items.map(function (x) { return x.topWidth; }));
    addRow('Countertop depth', items.map(function (x) { return x.topDepth; }));
    addRow('Storage', items.map(function (x) { return x.storage; }));
    addRow('Hardware', items.map(function (x) { return x.hardware; }));
    addRow('Sink layout', items.map(function (x) { return x.sink; }));
    addRow('Installation', items.map(function (x) { return x.mounting; }));
    addRow('Cabinet material', items.map(function (x) { return x.material; }));
    addRow('SKU', items.map(function (x) { return x.sku; }));
    addRow('Availability / ETA', items.map(function (x) { return x.eta; }));
    body.appendChild(table);
  }

  document.addEventListener('change', function(event){
    if(!event.target.matches('[data-wv-compare-differences]')) return;
    differencesOnly=event.target.checked;
    renderTable(event.target.closest('dialog'),readItems());
  });

  function syncUi(message) {
    var items = readItems();
    var ui = ensureCompareUi();
    var keys = items.map(keyFor);
    document.querySelectorAll('[data-wv-compare]').forEach(function (button) {
      var service = isService(itemFromButton(button));
      button.hidden = service;
      button.disabled = service;
      var selected = keys.indexOf(keyFor(itemFromButton(button))) !== -1;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var label = button.querySelector('[data-wv-compare-label]');
      if (label) label.textContent = selected ? 'Added to compare' : 'Compare';
    });
    ui.tray.hidden = items.length === 0;
    var counts = ui.tray.querySelectorAll('[data-wv-compare-count]');
    var hint = ui.tray.querySelector('[data-wv-compare-hint]');
    var open = ui.tray.querySelector('[data-wv-compare-open]');
    counts.forEach(function (count) { count.textContent = String(items.length); });
    if (hint) hint.textContent = message || (items.length < 2 ? 'Select at least 2 and up to 4 vanities.' : 'Ready to compare.');
    if (open) {
      open.disabled = items.length < 2;
      var compareLabel = items.length < 2
        ? 'Select one more vanity to compare'
        : 'Compare ' + items.length + ' selected vanities';
      open.setAttribute('aria-label', compareLabel);
      open.setAttribute('title', compareLabel);
      ui.tray.setAttribute('title', compareLabel);
    }

    // Mobile comparison lives in the same sticky capsule as the 1 / 2 density
    // switch. This keeps the navigation dock and floating Filter control clear.
    document.querySelectorAll('[data-wv-mobile-compare]').forEach(function (button) {
      button.hidden = items.length === 0;
      button.disabled = items.length < 2;
      button.setAttribute('aria-label', 'Compare ' + items.length + ' of ' + MAX_COMPARE + ' selected products');
      var mobileCount = button.querySelector('[data-wv-mobile-compare-count]');
      if (mobileCount) mobileCount.textContent = String(items.length) + '/' + String(MAX_COMPARE);
    });

    renderTable(ui.dialog, items);
  }

  function toggleCompare(button) {
    var item = itemFromButton(button);
    if (isService(item)) return;
    var key = keyFor(item);
    var items = readItems();
    var index = items.findIndex(function (x) { return keyFor(x) === key; });
    if (index >= 0) {
      items.splice(index, 1);
      writeItems(items);
      syncUi();
      emit('willow_compare_remove', { product_handle: item.handle, variant_id: item.variantId });
      return;
    }
    if (items.length >= MAX_COMPARE) {
      syncUi('Maximum 4 products. Remove one to add another.');
      return;
    }
    items.push(item);
    writeItems(items);
    syncUi();
    emit('willow_compare_add', { product_handle: item.handle, variant_id: item.variantId });
  }

  function syncCardFromFinish(swatch) {
    var card = swatch.closest('.product-card');
    if (!card) return;
    var compare = card.querySelector('[data-wv-compare]');
    var eta = card.querySelector('[data-wv-card-eta]');
    if (eta && swatch.dataset.eta) eta.textContent = swatch.dataset.eta;
    if (!compare) return;

    var previousKey = keyFor(itemFromButton(compare));
    var items = readItems();
    var selectedIndex = items.findIndex(function (item) { return keyFor(item) === previousKey; });

    ['productId','variantId','handle','title','url','image','price','finish','width','sink','mounting','material','sku','eta'].forEach(function (name) {
      if (swatch.dataset[name] != null && swatch.dataset[name] !== '') compare.dataset[name] = swatch.dataset[name];
    });

    if (selectedIndex >= 0) {
      var nextItem = itemFromButton(compare);
      var nextKey = keyFor(nextItem);
      var updatedItems = [];
      items.forEach(function (item, index) {
        if (index === selectedIndex) updatedItems.push(nextItem);
        else if (keyFor(item) !== nextKey) updatedItems.push(item);
      });
      writeItems(updatedItems);
    }
    syncUi();
  }

  function syncAvailabilityToggle() {
    var input = document.querySelector('form[is="facet-form"] input[name="filter.v.availability"]');
    var active = input ? input.checked : false;
    if (!input) {
      var url = new URL(window.location.href);
      active = url.searchParams.getAll('filter.v.availability').some(function (value) {
        return value === '1' || value === 'true';
      });
    }
    document.querySelectorAll('[data-wv-availability-toggle]').forEach(function (button) {
      button.setAttribute('aria-checked', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
    });
  }

  function placeCardCompareButtons() {
    document.querySelectorAll('.product-card').forEach(function (card) {
      var compare = card.querySelector('[data-wv-compare]');
      var actions = card.querySelector('.wv-card-actions');
      var media = card.querySelector('.product-card__media');
      var quickAdd = media && media.querySelector('.quick-add');
      if (!compare || !actions || !media) return;

      if (quickAdd) quickAdd.classList.remove('wv-card-action-stack');
      if (compare.parentNode !== media) media.appendChild(compare);
      compare.classList.add('wv-card-compare--media');
      compare.classList.remove('wv-card-compare--with-cart');
      actions.classList.toggle('wv-card-actions--empty', actions.children.length === 0);
    });
  }

  function syncAll() {
    placeCardCompareButtons();
    syncUi();
    syncAvailabilityToggle();
  }

  function toggleAvailability(button) {
    var next = button.getAttribute('aria-checked') !== 'true';
    var input = document.querySelector('form[is="facet-form"] input[name="filter.v.availability"]');
    emit('willow_quick_filter', { filter_name: 'availability', filter_state: next ? 'on' : 'off' });
    if (input) {
      input.checked = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      button.setAttribute('aria-checked', next ? 'true' : 'false');
      button.classList.toggle('is-active', next);
      return;
    }
    var url = new URL(window.location.href);
    if (next) url.searchParams.set('filter.v.availability', '1');
    else url.searchParams.delete('filter.v.availability');
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  // The product-card touch handler stops propagation during its capture phase and
  // may otherwise turn action taps into card navigation. Intercept Compare at the
  // document boundary first; finish selection still updates metadata after its tap.
  document.addEventListener('click', function (event) {
    var compare = event.target.closest && event.target.closest('[data-wv-compare]');
    if (compare) {
      event.preventDefault();
      event.stopPropagation();
      toggleCompare(compare);
      return;
    }
    var finish = event.target.closest && event.target.closest('.wv-card-fin');
    if (finish) setTimeout(function () { syncCardFromFinish(finish); }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var availability = event.target.closest && event.target.closest('[data-wv-availability-toggle]');
    if (availability) {
      event.preventDefault();
      toggleAvailability(availability);
      return;
    }
    var clear = event.target.closest && event.target.closest('[data-wv-compare-clear]');
    if (clear) {
      writeItems([]);
      syncUi();
      return;
    }
    var open = event.target.closest && event.target.closest('[data-wv-compare-open]');
    if (open) {
      var dialog = ensureCompareUi().dialog;
      renderTable(dialog, readItems());
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      hydrateComparison(dialog);
      emit('willow_compare_open', { product_count: readItems().length });
      return;
    }
    var close = event.target.closest && event.target.closest('[data-wv-compare-close]');
    if (close) {
      var closeDialog = close.closest('dialog');
      if (closeDialog && typeof closeDialog.close === 'function') closeDialog.close();
      else if (closeDialog) closeDialog.removeAttribute('open');
      return;
    }
    var remove = event.target.closest && event.target.closest('[data-wv-compare-remove]');
    if (remove) {
      var removeKey = remove.dataset.wvCompareRemove;
      var nextItems = readItems().filter(function (x) { return keyFor(x) !== removeKey; });
      writeItems(nextItems);
      syncUi();
      if (!nextItems.length) {
        var removeDialog = remove.closest('dialog');
        if (removeDialog && typeof removeDialog.close === 'function') removeDialog.close();
      }
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('input[name="filter.v.availability"]')) {
      setTimeout(syncAvailabilityToggle, 0);
    }
  });
  document.addEventListener('collection:reloaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('pageshow', syncAll);
  window.addEventListener('popstate', function () { setTimeout(syncAvailabilityToggle, 0); });
  var compareTrayResizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(compareTrayResizeTimer);
    compareTrayResizeTimer = setTimeout(function () {
      var tray = document.querySelector('[data-wv-compare-tray]');
      if (tray) placeCompareTray(tray);
      placeCardCompareButtons();
    }, 100);
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) syncUi();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();



